export default __webpack_public_path__ + "media/color/polis-bf27dacc.svg";